


















































































import Vue, { PropType } from "vue";
import draggable from "vuedraggable";
import { SortingSelectionItem } from "@/features/analytics/types";

export default Vue.extend({
  components: {
    draggable,
  },

  props: {
    title: { type: String, required: true },
    reportTypeInput: { type: Number, required: true },
    sortingSelectionItemsInput: {
      type: Array as PropType<number[]>,
      required: true,
    },
    loading: { type: Boolean, required: true },
    selectionItems: {
      type: Array as PropType<SortingSelectionItem[]>,
      required: true,
    },
  },

  data() {
    return {
      selectedCategory: "" as string,
    };
  },

  computed: {
    localSortingSelectionItemsInput: {
      get() {
        return this.sortingSelectionItemsInput;
      },
      set(val) {
        return this.$emit("update:sortingSelectionItemsInput", val);
      },
    },
    category(): SortingSelectionItem[] {
      if (this.selectionItems.length === 0) return [];
      return this.selectionItems.filter(
        (ele, index, self) => self.findIndex(e => e.category === ele.category) === index
      );
    },
  },

  methods: {
    selectCategory(category: string) {
      this.selectedCategory = category;
    },
    equalsCategory(sortingSelectionItem: SortingSelectionItem): boolean {
      return sortingSelectionItem.category === this.selectedCategory;
    },
    closeSortingSelectionItem(id: number) {
      this.localSortingSelectionItemsInput = this.sortingSelectionItemsInput.filter(
        value => value !== id
      );
    },
    displaySortingSelectionItemNameById(id: number): string | undefined {
      const item = this.selectionItems.find(item => item.id === id);
      return item?.name;
    },
  },
});
